export default __webpack_public_path__ + "static/media/CS23.141911f7.jpg";